import { Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        marginRight: 6,
        width: Platform.select({ web: 24, default: 18 }),
        height: 20,
        alignSelf: 'center',
    },
});

export default styles;
